import axios from "axios";

const ENDPOINT = "/api/v2/tracking/filter_event";

// Relays a filter event to the backend, which forwards it to Mixpanel server-side (bypassing ad
// blockers that block the browser SDK). Fire-and-forget: tracking must never block or break the UI,
// so any request error is swallowed.
const trackFilterEvent = async (event, properties) => {
  try {
    await axios.post(ENDPOINT, { event, ...properties });
  } catch {
    // Ignore — tracking failures must never surface to the user.
  }
};

export { trackFilterEvent };
